// extracted by css-extract-rspack-plugin
export default {"errorBlock":"FilterSelectList_errorBlock__eBLjl","select":"FilterSelectList_select__tap2g"};